<template>
    <div>
        <OnboardingPage
            v-if="step === 1"
            :selectedMandateType="selectedMandateType"
            :disableMandateType="disableMandateType"
            :loading="isLoading"
            @mandateTypeSelected="handleMandateTypeSelected"
        />
        <OnboardingCompanyPage
            v-if="step === 2"
            :selectedMandateType="selectedMandateType"
            :company="company"
            @representativeSelected="handleLegalRepresentativeSelection"
        />
        <OnboardingElectronicAddressPage
            v-if="step === 3"
            :siren="company.legal_france.siren"
            @addressSelected="handleAddressSelected"
        />
        <OnboardingLegalRepresentativePage
            v-if="step === 4"
            :legalRepresentative="legalRepresentative"
            :selectedMandateType="selectedMandateType"
            :company="company"
        />
    </div>
</template>
<script>
import OnboardingPage from 'vcomponents/pa/mandate/Onboarding/OnboardingPage.vue';
import OnboardingCompanyPage from 'vcomponents/pa/mandate/Onboarding/OnboardingCompanyPage.vue';
import OnboardingElectronicAddressPage from 'vcomponents/pa/mandate/Onboarding/OnboardingElectronicAddressPage.vue';
import OnboardingLegalRepresentativePage from 'vcomponents/pa/mandate/Onboarding/OnboardingLegalRepresentativePage.vue';
import { getAccountInformation } from 'api/account/account';
import { getEInvoicingMandate } from 'api/corp/corp';

import { createNamespacedHelpers } from 'vuex';
const { mapGetters: corpMapGetters } = createNamespacedHelpers('corp');
const { mapState: mapStateUser } = createNamespacedHelpers('user');

export default {
    components: {
        OnboardingPage,
        OnboardingCompanyPage,
        OnboardingElectronicAddressPage,
        OnboardingLegalRepresentativePage,
    },
    data() {
        return {
            step: 1,
            selectedMandateType: [],
            company: null,
            legalRepresentative: null,
            isLoading: false,
            mandates: [],
            disableMandateType: false,
        };
    },
    computed: {
        ...mapStateUser(['isAdmin']),
        ...corpMapGetters({
            companyInformationLocked: 'getCompanyInformationLocked',
        }),
    },
    created() {
        if (this.companyInformationLocked && this.isAdmin) {
            this.isLoading = true;

            const accountPromise = getAccountInformation()
                .then((response) => {
                    this.company = response.data;
                })
                .catch(() => {
                    this.$pushToast({
                        type: 'error',
                        message: this.$t.__('CompanyInformation.fetch.error'),
                    });
                });

            const mandatePromise = getEInvoicingMandate()
                .then((response) => {
                    this.mandates = response.data;
                })
                .catch((error) => {
                    if (error.response.status !== 404) {
                        this.$pushToast({
                            type: 'error',
                            icon: true,
                            text: this.$t.__('settings.mandate.fetch_error'),
                        });
                    } else {
                        this.mandates = [];
                    }
                })
                .finally(() => {
                    if (
                        this.mandates.length &&
                        this.mandates.some((mandate) => mandate.types.includes('issue'))
                    ) {
                        this.selectedMandateType = ['issue', 'receipt'];
                        this.disableMandateType = true;
                    }
                    this.isLoading = false;
                });

            Promise.all([accountPromise, mandatePromise]).finally(() => {
                this.isLoading = false;
            });
        }
    },
    methods: {
        handleMandateTypeSelected(mandateType) {
            if (mandateType === 'receipt') {
                this.selectedMandateType = ['issue', 'receipt'];
            } else {
                this.selectedMandateType = [mandateType];
            }
            this.step = 2;

            this.sendTrackEvent('Flow PA > Step 1 Continue Clicked', {
                mandateType: this.selectedMandateType,
            });
        },
        handleLegalRepresentativeSelection(data) {
            this.legalRepresentative = data;
            this.step = this.selectedMandateType.includes('receipt') ? 3 : 4;

            this.sendTrackEvent('Flow PA > Step 2 Continue Clicked', {
                mandateType: this.selectedMandateType,
            });
        },
        handleAddressSelected(address) {
            this.company.electronicAddress = address;
            this.step = 4;

            this.sendTrackEvent('Flow PA > Step 3 Continue Clicked', {
                mandateType: this.selectedMandateType,
            });
        },
        sendTrackEvent(eventName, data) {
            if (window.Intercom) {
                window.Intercom('trackEvent', eventName, data);
            }

            if (window.pendo?.accountId) {
                window.pendo.track(eventName, data);
            }
        },
    },
};
</script>
